export default __webpack_public_path__ + "static/media/Simran Kathuria.5fe6519c.jpg";